import { render } from "./InvoiceListPage.vue?vue&type=template&id=2597f0b8&ts=true"
import script from "./InvoiceListPage.vue?vue&type=script&lang=ts"
export * from "./InvoiceListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__